// extracted by mini-css-extract-plugin
export default {"root":"Mobile3DViewer_root__3eeSE"};